export default __webpack_public_path__ + "static/media/americanExpressCard.219147db.svg";